export default "__VITE_ASSET__CDJnuOMQ__"